import { Aspect } from "@xanadu/model";
import { Injectable } from "@angular/core";
import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";

@Injectable({
    providedIn: 'root'
})
export class AspectCache extends DataCache<Aspect> {

    constructor(
        dataService: DataService
    ) {
        super(Aspect, dataService);
    }
}
